/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustLocationBoxDimensionReqVo
 */
export interface AdminStockAdjustLocationBoxDimensionReqVo {
    /**
     * 会员ID
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxDimensionReqVo
     */
    userId: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxDimensionReqVo
     */
    warehouseId: number;
    /**
     * 箱ID
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxDimensionReqVo
     */
    boxId: number;
    /**
     * 长(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxDimensionReqVo
     */
    length: number;
    /**
     * 宽(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxDimensionReqVo
     */
    width: number;
    /**
     * 高(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxDimensionReqVo
     */
    height: number;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationBoxDimensionReqVo interface.
 */
export function instanceOfAdminStockAdjustLocationBoxDimensionReqVo(value: object): value is AdminStockAdjustLocationBoxDimensionReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    if (!('boxId' in value) || value['boxId'] === undefined) return false;
    if (!('length' in value) || value['length'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    return true;
}

export function AdminStockAdjustLocationBoxDimensionReqVoFromJSON(json: any): AdminStockAdjustLocationBoxDimensionReqVo {
    return AdminStockAdjustLocationBoxDimensionReqVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationBoxDimensionReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationBoxDimensionReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'warehouseId': json['warehouseId'],
        'boxId': json['boxId'],
        'length': json['length'],
        'width': json['width'],
        'height': json['height'],
    };
}

export function AdminStockAdjustLocationBoxDimensionReqVoToJSON(json: any): AdminStockAdjustLocationBoxDimensionReqVo {
    return AdminStockAdjustLocationBoxDimensionReqVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationBoxDimensionReqVoToJSONTyped(value?: AdminStockAdjustLocationBoxDimensionReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'warehouseId': value['warehouseId'],
        'boxId': value['boxId'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
    };
}

